/** Canonical project tags — use these constants to keep labels consistent. */
export const TAG = {
  // Development
  REACT: "ReactJS",
  NEXT: "NextJS",
  NEST: "NestJS",
  REACT_ROUTER: "React Router",
  VITE: "Vite",
  EXPRESS: "Express",
  JAVASCRIPT: "JavaScript",
  JQUERY: "jQuery",
  BOOTSTRAP: "Bootstrap CSS",
  TAILWIND: "Tailwind CSS",
  DAISYUI: "DaisyUI",

  // Design tools
  FIGMA: "Figma",
  PROCREATE: "Procreate",
  AFFINITY_DESIGNER: "Affinity Designer",
  AFFINITY_PUBLISHER: "Affinity Publisher",

  // UX / UI
  UX_UI: "UX/UI",
  USABILITY: "Usability Testing",
  WIREFRAMING: "Wireframes",
  LO_FI_WIREFRAMES: "Lo-Fi Wireframes",
  MID_FI_WIREFRAMES: "Mid-Fi Wireframes",
  HI_FI_WIREFRAMES: "Hi-Fi Wireframes",
  PROTOTYPING: "Prototype",
  INFO_ARCH: "Information Architecture",
  MOBILE_DESIGN: "Mobile App Design",
  PRODUCT_DESIGN: "Product Design",
  HEALTHCARE_UX: "Healthcare UX",

  // Creative / print
  EDITORIAL: "Editorial Design",
  PRINT: "Print Design",
  ILLUSTRATION: "Digital Illustration",
  TYPOGRAPHY: "Typography",
  LAYOUT: "Layout Design",
  CONTENT_DESIGN: "Content Design",

  // Domain / platform
  ECOMMERCE: "E-commerce",
  IOT: "IoT",
  CMS: "CMS",
  API: "API Integration",
};
